'use strict';
angular
    .module('MW.ContactManager.OutreachListFactory', [
        'MW.Framework.CoreCompanyService',
        'MW.ContactManager.OutreachService',
        'MW.Framework.TextFilters',
        'MW.Framework.TranslationService',
        'MW.Framework.CoreUserService',
        'MW.Framework.TimezoneService',
        'MW.Framework.ICMUserService'
    ])
    .factory('OutreachListFactory', [
        '$q',
        '$filter',
        'CoreCompanyService',
        'OutreachService',
        'translationService',
        'CoreUserService',
        'TimezoneService',
        'moment',
        'ICMUserService',
        function($q, $filter, CoreCompanyService, OutreachService, translationService, CoreUserService, TimezoneService, moment, ICMUserService) {

            function OutreachListFactory() {
                this.OutreachService = OutreachService;
                this.$q = $q;
                this.$filter = $filter;
                this.outreachEmails = [];
                this.totalEmails = 0;
                this.translationService = translationService;
                this.CoreUserService = CoreUserService;
                this.TimezoneService = TimezoneService;
                this.moment = moment;
                this.ICMUserService = ICMUserService;
            }

            OutreachListFactory.prototype.getAllEmails = function getAllEmails(contactId, emailAddressArray, sortField, sortOrder, page, pageSize, filterByType, findText) {
                var defer = $q.defer(),
                    searchCriteria = {};

                if(contactId){
                    searchCriteria.contactId = contactId;
                }

                if(emailAddressArray){
                    searchCriteria.emailAddresses = emailAddressArray;
                }

                if(sortField){
                    searchCriteria.sortField = sortField;
                }

                if(sortOrder){
                    searchCriteria.sortOrder = sortOrder;
                }

                if(page >= 0){
                    searchCriteria.page = page;
                }

                if(pageSize){
                    searchCriteria.pageSize = pageSize;
                }

                if(filterByType){
                    searchCriteria.filterByStatus = filterByType;
                }

                if(findText){
                    searchCriteria.findQ = findText;
                }


                this.OutreachService.getAllEmails(searchCriteria).then(function(response) {
                    this.outreachEmails = []; // This is required to populate fresh data
                    this.totalEmails = response.total || 0;
                    this.populateEmailsList(response.hits); // Creating object for view all outreach emails
                    defer.resolve({hits: this.outreachEmails, total: this.totalEmails});
                }.bind(this),
                function(error) {
                    defer.reject(error);
                }.bind(this));

                return defer.promise;
            };

            OutreachListFactory.prototype.populateEmailsList = function populateEmailsList(emailsList) {
                var statusObject = {
                    'sent': this.translationService.getLocalizedString('Sent'),
                    'sending': this.translationService.getLocalizedString('Sending'),
                    'errors': this.translationService.getLocalizedString('Errors'),
                    'draft': this.translationService.getLocalizedString('Draft'),
                    'scheduled': this.translationService.getLocalizedString('Scheduled')
                },
                noSubject = this.translationService.getLocalizedString('No Subject'),
                noFrom = this.translationService.getLocalizedString('No Sender'),
                noRecipients = this.translationService.getLocalizedString('No Recipients'),
                notApplicable = this.translationService.getLocalizedString('N/A');

                if(emailsList && emailsList.length > 0) {
                    for(var i = 0; i < emailsList.length; i++) {
                        var listObject = emailsList[i],
                            emailsListObject = {
                                _id: listObject._id,
                                type: 'email',
                                companyId : listObject.companyId,
                                created : this.$filter('icmTranslateDate')(listObject.created, 'll'),
                                fromAddress : listObject.fromAddress,
                                scheduledDate : this.$filter('icmTranslateDate')(listObject.scheduledDate, 'll'),
                                scheduledTimeStamp : this.$filter('mwConvertDateToUserTimezone')(listObject.scheduledDate, 'mediumDate') +' '+ this.$filter('mwConvertDateToUserTimezone')(listObject.scheduledDate, 'hh:mm a') +' '+ this.ICMUserService.getTimezoneName(),
                                scheduledDateStamp : this.moment.utc(listObject.scheduledDate).format('X'),
                                subject : listObject.subject,
                                status : statusObject[listObject.status],
                                distributionStatus : listObject.status,
                                approvedSenderName: listObject.approvedSender ? listObject.approvedSender.name : notApplicable,
                                approvedSenderEmail : listObject.approvedSender ? listObject.approvedSender.email : notApplicable,
                                translatedKeys : {
                                    noSubject : noSubject,
                                    noFrom : noFrom,
                                    noRecipients : noRecipients,
                                    noDate : notApplicable
                                },
                                to : {
                                    contactRecipients: listObject.recipientsData,
                                    mediaListNames: listObject.mediaListNames
                                }
                            };

                        //delete scheduledTimeStamp form object if scheduledDate is undefined
                        if (emailsListObject.scheduledDate === undefined || emailsListObject.scheduledDate === null){
                            delete emailsListObject.scheduledTimeStamp;
                        }

                        this.outreachEmails.push(emailsListObject);
                    }
                }
            };

            return OutreachListFactory;
        }
    ]);
